module.exports = __webpack_public_path__ + "img/reports.e1220c92.svg";